import { j as r } from "./jsx-runtime.DGlMoOmv.js";
import { useFormContext as h } from "react-hook-form";
import { d as F, e as j, f as p, b as u, g as b } from "./Form.LdCd9gH2.js";
import { c as f } from "./index.CxSWpsOB.js";
import { C as g } from "./Checkbox.PFuVDlpI.js";
const w = ({
  className: a,
  checkboxClassName: n,
  label: s,
  subcopy: d,
  description: i,
  note: c,
  name: l,
  readOnly: x,
  variant: t,
  ...e
}) => {
  const {
    control: C
  } = h(), m = t === "box";
  return /* @__PURE__ */ r.jsx(F, { control: C, name: l, render: ({
    field: o
  }) => /* @__PURE__ */ r.jsxs(j, { disabled: e.disabled, readOnly: x, className: a, children: [
    !!s && /* @__PURE__ */ r.jsx(p, { subcopy: d, required: e.required, children: s }),
    /* @__PURE__ */ r.jsx(u, { forwardErrorMsg: !0, children: /* @__PURE__ */ r.jsx(g, { checked: o.value, onCheckedChange: o.onChange, className: n, description: i, variant: t, ...e, ...o }) }),
    /* @__PURE__ */ r.jsx(b, { className: f({
      "tw-pl-24 !tw-mt-0": !m,
      "tw-pl-0 tw-mt-8": m
    }), children: c })
  ] }) });
};
w.displayName = "CheckboxField";
export {
  w as C
};
//# sourceMappingURL=CheckboxField.CL5A3il7.js.map
